<script>
const models = window.models
import { jsPDF } from "jspdf";

import { selection, activeStep } from './lib.js';

let rendering = false;
window.pdf = false;

async function downloadBlob(content, contentType, fileName) {
    var blob = new Blob([ content ], { type : contentType });
    if(navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
    } else {
        let url = (window.URL || window.webkitURL).createObjectURL( blob );
        let save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
        save_link.href = url;
        save_link.download = fileName;
        var event = document.createEvent("MouseEvents");
        event.initMouseEvent(
            "click", true, false, window, 0, 0, 0, 0, 0,
            false, false, false, false, 0, null
        );
        save_link.dispatchEvent(event);
    }
}

function generatePDF() {
	console.log('generating pdf');
	rendering = true;
    let canvasDoc = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: 'letter',
		autoPaging: 'text',
    });


    canvasDoc.html(document.getElementById('byo-pdf-summary'), {
        html2canvas: {
            scale: 1
        },
        callback: function () {
			console.log('generated pdf');
            let blob =  canvasDoc.output('blob');
            rendering = false;

            let fileField = document.querySelector('.file_upload-wrap input.nf-element');
            let file = new File([blob], "byo-generated.pdf");
            let container = new DataTransfer();

            container.items.add(file);
            fileField.files = container.files;
            jQuery(fileField).change();
			window.pdf = blob;
        }
    });
}

function showModal(id) {
    var modal = document.querySelector(id);
    modal.showModal();
	var outer = modal.querySelector('.outer');

    modal.addEventListener('click', (e) => {
		if(e.target == modal || e.target == outer) {
            modal.close();
        }
    });

	modal.querySelector('.close').addEventListener('click', () => {
		modal.close();
	});
    populateForm();

	jQuery(document).on('nfFormSubmitResponse', () => {
		console.log('ok1');
		if(window.pdf) {
            downloadBlob(window.pdf, 'application/pdf', 'byo.pdf');
		}
	})
}

setTimeout(generatePDF, 100);

</script>

<div class="byo-summary js-summary model-summary container active" data-model-year="2025" data-model="{$selection.code}">
    <h2 class="byo-heading -summary">
        { $selection.title }
    </h2>
    <p class="byo-text">Summary</p>
    <div class="byo-summary__content js-sticky-wrap">
        <div class="byo-summary__images">
            <div class="byo-summary__ext-container">
                <div class="byo-summary__ext-inner">
                    <img src="{ $selection.chosenPaint.image }" alt="{ $selection.title }" class="byo-summary__exterior">
                </div>
            </div>
            <img src="{ $selection.chosenFloorplan.image }" alt="" class="byo-summary__floorplan">
            <div class="model-decor-outer">
            {#each Object.entries($selection.interiorChoices) as [name, options]}
                <div class="model-decor-options__image-section active">
                    {#each $selection.interiorChoices[name].swatches as swatch}
                    <div class="model-decor-options__option-wrapper">
                        <img src="{swatch.image}" alt="Shadow" class="model-decor-options__image">
                        <h4 class="model-decor-options__image-title">{swatch.name}</h4>
                    </div>
                    {/each}
                </div>
            {/each}
            </div>
        </div>
        <div class="byo-summary__text js-sticky">
            <h3 class="byo-summary__button-title"> Your { $selection.title }</h3>
            <p class="byo-summary__title">Exterior </p>
            <h3 class="byo-summary__selection">{ $selection.chosenPaint.name }</h3>
            <p class="byo-summary__title">Interior </p>
            <h3 class="byo-summary__selection interior">
            {#each Object.entries($selection.interiorChoices) as [name, options]}
                <span>{options.name}</span>
            {/each}
            </h3>
            <p class="byo-summary__title"> Floor Plan </p>
            <h3 class="byo-summary__selection">{ $selection.chosenFloorplan.name }</h3>
            <p class="byo-summary__copy"> Now that you've built your dream Tiffin, download a PDF detailing your motorhome and take it to your closest Tiffin dealer for pricing and purchasing information. </p>
            <div class="byo-summary__buttons">
				<button on:click="{() => { if(!pdf) { generatePDF(); } showModal('#modal-popup-save')}}" class="button byo-summary__button">Save Build</button>
            </div>
			<button on:click="{() => { window.pdf = false; $selection = {'chosenPaint': {}, 'interiorChoices': {}, 'chosenFloorplan': {}, 'options': {} }; window.scrollTo(0,0); $activeStep = 0; }}" class="build-new"> Build A New Model</button>
        </div>
    </div>
</div>

<div id="byo-pdf-summary" class="byo-pdf-summary {rendering ? 'rendering' : ''}">

    <span class="byo-pdf-summary__vanleigh-logo">&nbsp;</span>

    <div class="byo-pdf-model">
        <div>
            <img src="/wp-content/themes/tiffin/images/logo-black.jpg" class="byo-pdf-summary__logo pdf-model-logo-image" style="display: block; width: 150px; height: 34px; max-height: 200px; margin-bottom: 5px;"/>
        </div>
        <div class="byo-pdf-model__contact-box">
            <h4>Your Custom Tiffin RV</h4>
            <h5><span class="pdf-model-selection">{ $selection.title }</span></h5>
            <p>Take this sheet to your closest Tiffin dealer for pricing or information.</p>
        </div>
    </div>

    <div class="byo-pdf-section-divider">
        <span>
            <span class="pdf-floorplan-selection">{ $selection.chosenFloorplan.name }</span> Floorplan
        </span>
    </div>

    <div class="byo-pdf-floorplan">
        <img src="{ $selection.chosenFloorplan.image }" class="byo-pdf-floorplan__image pdf-floorplan-image svg-image" style="max-height: 200px;" />
    </div>

    <div class="byo-pdf-section-divider">
        <span>
            Decor & Exterior Options
        </span>
    </div>

    <div class="byo-pdf-decor">
        {#each Object.entries($selection.interiorChoices) as [name, options]}
			<table class="{$selection.interiorChoices[name].swatches.length < 3 ? 'short' : ''}">
			<tr>
				<td class="decor-selection" colspan="5">{ name } - { $selection.interiorChoices[name].name }</td>
			</tr>
                {#each $selection.interiorChoices[name].swatches as swatch, idx}
					{#if idx % 5 == 0}
						<tr>
							{#each Array(5) as _, j}
							{#if $selection.interiorChoices[name].swatches[idx+j]}
							<td>
								<div>
								<img src="{$selection.interiorChoices[name].swatches[idx+j].image}" alt="Shadow" class="model-decor-options__image" />
								<h4 class="model-decor-options__image-title">{$selection.interiorChoices[name].swatches[idx+j].name}</h4>
								</div>
							</td>
							{/if}
							{/each}
						</tr>
					{/if}
                {/each}
			</table>
        {/each}
    </div>

    {#if Object.keys($selection.options).length > 0}
    <div class="byo-pdf-section-divider">
        <span>
            Optional Features
        </span>
    </div>

    <ul class="byo-pdf-features pdf-addon-selection">
        {#each Object.entries($selection.options) as [heading, option]}
			{#if Array.isArray(option) }
				{#each option as suboption}
					<li>{ heading } - { suboption.name }</li>
				{/each}
			{:else}
				<li>{ heading } - { option.name }</li>
			{/if}
        {/each}
    </ul>
    {/if}


</div>

<div class="continue-bar js-continue-bar -active">
    <button class="continue-bar__text button -back js-forward" on:click="{() => { $activeStep = 4; window.scrollTo(0,0);}}">Prev</button>
</div>

<style lang="scss">
.byo-summary__content {
    display: flex;
}

@media (max-width: 1100px) {
    .byo-summary__content {
        display: block;
    }

    .byo-summary__images, .byo-summary__text {
        width: 100% !important;
    }
}

.interior span {
    &:after {
        content: ' / ';

    }

    &:last-child:after {
        content: '';
    }
}

.model-decor-outer {
    display: flex;

    & > div {
        margin-right: 1%;

        &:last-child {
            margin-right: 0;
        }

    }

    @media (max-width: 800px) {
        flex-wrap: wrap;
        & > div {
            width: 100%;
        }
    }
}

.lower-buttons {
    margin-top: 48px;
    display: flex;
}

.byo-summary__text {
    margin-top: 0 !important;
}

.white-button {
    background: #fff !important;
    color: #000 !important;
}

.byo-summary__buttons {
    background: none !important;

    button {
        margin-bottom: 0 !important;
        width: 100%;
        padding: 15px 30px !important;
        box-sizing: border-box;
    }

}

.build-new {
    margin-top: 60px;
    width: 100%;
    background: none !important;
    border: none !important;
    color: #000 !important;

    &:before {
        content: '←';
    }
}



//Main Page Wrapper
#byo-pdf-summary {

    //border: 1px solid #333;
    padding: 20px;
    //outline: 1px solid #000;
    outline-offset: -10px;
    font-family: arial;

    transform: translateX(100vw);
    height: 0;
    display: none;

    &.rendering {
        position: relative;
        display: block;
        width: 612px;
        height: 791px;
        transform: translateX(0);
    }

}

.byo-pdf-image-preload {
    transform: translateY(-100vw);
    height: 0;
    position: absolute;
    display: block;

}

.byo-pdf-summary {

    &__vanleigh-logo {
        max-width: 100px;
        display: block;
        margin-left: 0;
    }

    &__logo {
        max-width: 150px;
        vertical-align: top;
        align-self: center;
        margin-bottom: 10pt;
        margin-left: auto;
        margin-right: auto;
    }

    &__heading {
        text-transform: uppercase;
        font-size: 12pt;
    }

}


//Section Divider Styles
.byo-pdf-section-divider {
    background: #000;
    color: #fff;
    display: block;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 10px;
    padding: 5px;
	clear: both;

    span {
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 1px;
    }
}

//Page Section Styles
.byo-pdf-model {
    max-height: 200px;
    margin-bottom: 10px;
    margin-top: 0px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    img {
        display: block;
        margin: 0;
        position: relative;
        top: -20px;
    }

    &__contact-box {
        border: 0.5pt solid #ccc;
        padding: 10px;
        font-size: 6pt;
        max-width: 250px;
        height: auto;
        position: relative;
        top: -20px;

        h4 {
            font-size: 5pt;
            text-transform: uppercase;
            margin-bottom: 5px;
            margin-top: 5px;
            line-height: 1;
            font-weight: bold;
            color: #777;
        }

        h5 {
            font-size: 9pt;
            text-transform: uppercase;
            margin-bottom: 5px;
            margin-top: 5px;
            font-weight: bold;
            line-height: 1;
        }

        p {
            margin-bottom: 0;
            line-height: 1.2;
            font-size: 9pt;
        }
    }
}

.byo-pdf-floorplan {

    &__image {
        display: inline-block;
        max-height: 200px;
    }
}

.byo-pdf-decor {

    &__option {
        width: calc(50% - 10px);

        strong {
            text-transform: uppercase;
            color: #999;
            letter-spacing: 1px;
            display: block;
            font-size: 6pt;
            line-height: 1;
        }

        span {
            font-size: 9pt;
        }
    }

	table.short {
		width: 49.5%;
		float: left;
	}

	td {
		width: 20%;
		padding: 0;
		background: #fff;

		img {
			max-width: 95px;
		}

		div {
			padding: 12px;
		}
	}

}

.byo-pdf-features {
    columns: 2 20px;
    list-style-type: none;
    font-size: 9pt;

    li {
        list-style-type: disc;
        margin-left: 9pt;
        display: inline-block;
    }
}
</style>

